import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'
import { IQueryProps } from '@/entities/Query'

/**
 * 部署一覧
 *
 * 部署データの一覧を返す
 */
export class FetchDivision implements APIRequest<Monitaro.FetchDivisionResponse> {
  response: Monitaro.FetchDivisionResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: IQueryProps
  constructor(query?: IQueryProps) {
    this.params = query
    this.path = `/divisions`
  }
}

/**
 * 部署データの追加
 *
 * 新規で医療品データを登録する
 */
export class PostDivision implements APIRequest<Monitaro.PostDivisionResponse> {
  response: Monitaro.PostDivisionResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Monitaro.DivisionRequest
  constructor(params: Monitaro.DivisionRequest) {
    this.params = params
    this.path = `/divisions`
  }
}

/**
 * 部署データの取得
 *
 * 指定されたIDの部署情報を返す
 */
export class GetDivision implements APIRequest<Monitaro.GetDivisionResponse> {
  response: Monitaro.GetDivisionResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(division: string) {
    this.path = `/divisions/${division}`
  }
}

/**
 * 部署データの更新
 *
 * 指定されたIDの部署データ更新する
 */
export class PutDivision implements APIRequest<Monitaro.PutDivisionResponse> {
  response: Monitaro.PutDivisionResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Monitaro.DivisionRequest
  constructor(division: string, params: Monitaro.DivisionRequest) {
    this.params = params
    this.path = `/divisions/${division}`
  }
}

/**
 * 部署データの削除
 *
 * 部署データを削除する
 */
export class DeleteDivision implements APIRequest<Monitaro.DeleteDivisionResponse> {
  response: Monitaro.DeleteDivisionResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(division: string) {
    this.path = `/divisions/${division}`
  }
}
